// extracted by mini-css-extract-plugin
module.exports = {"HeroSection":"HeroSection_HeroSection__4Yx1l","HeroSectionBG":"HeroSection_HeroSectionBG__3fo1M","HeroContentDiv":"HeroSection_HeroContentDiv__1fX4_"};